import helper from 'util/helpers'
import eventBus from '@/event_bus'

const getDefaultState = () => {
  return {
    selectedScenario: undefined,
    scenarios: [],
    selectedFlow: [],
    isSelectedFlow: false,
    treeNodes: [],
    deletedNodes: [],
    channelCounts: 0,
    disableScenarioDialog: false,
    disableScenarioResultDialog: false,
    scenariosLength: 0
  }
}
const state = getDefaultState()

const getters = {
  selectedScenario: (state) => {
    return state.selectedScenario
  },
  scenarios: (state) => {
    return state.scenarios
  },
  scenariosLength: (state) => {
    return state.scenarios.length
  },
  selectedFlow: (state) => {
    return state.selectedFlow
  },
  treeNodes: (state) => {
    return state.treeNodes
  },
  deletedNodes: (state) => {
    return state.deletedNodes
  },
  isSelectedFlow: (state) => {
    return state.isSelectedFlow
  },
  channelCounts: (state) => {
    return state.channelCounts
  },
  findNodeByCode: (state) => (code) => {
    let findNode
    if (state.selectedScenario.scenarioSnapshotFlowViews[0].data.code === code) {
      findNode = state.selectedScenario.scenarioSnapshotFlowViews[0]
    } else {
      for (let index = 0; index < state.selectedScenario.scenarioSnapshotFlowViews[0].children.length; index++) {
        findNode = state.selectedScenario.scenarioSnapshotFlowViews[0].children[index]
        if (findNode.data.code === code) {
          break
        } else {
          findNode = helper.findTreeNodeByCode(findNode, code)
        }
        if (findNode !== undefined) {
          break
        }
      }
    }
    return findNode
  },
  displayTreeText: (state, getters) => {
    if (state.isSelectedFlow) {
      let names = []
      let node = state.selectedFlow
      names.push(node.text)
      while (true) {
        node = getters.findNodeByCode(node.data.parentCode)
        if (node === undefined) {
          break
        }
        names.push(node.text)
      }
      return names.reverse().join(' > ')
    }
    return ''
  },
  disableScenarioDialog: (state) => {
    return state.disableScenarioDialog
  },
  disableScenarioResultDialog: (state) => {
    return state.disableScenarioResultDialog
  }
}

const actions = {
  changeSelectedScenario (context, scenario) {
    context.commit('changeSelectedScenario', scenario)
  },
  addScenario (context, scenario) {
    context.commit('addScenario', scenario)
  },
  deleteScenario (context, scenario) {
    context.commit('deleteScenario', scenario)
  },
  changeSelectedFlow (context, flow) {
    context.commit('changeSelectedFlow', flow)
  }
}

const mutations = {
  changeSelectedScenario (state, scenario) {
    state.selectedScenario = scenario
    state.treeNodes = scenario.scenarioSnapshotFlowViews
  },
  changeChannelCounts (state, count) {
    state.channelCounts = count
  },
  addScenario (state, scenario) {
    state.scenarios.unshift(scenario)
  },
  deleteScenario (state, scenario) {
    const scenarioIndex = state.scenarios.map(scenario => scenario.scenarioId).indexOf(scenario.scenarioId)

    if (scenarioIndex === -1) {
      return
    }

    state.scenarios.splice(scenarioIndex, 1)
    if (state.scenarios.length > 0) {
      eventBus.$emit('change-select-scenario', state.scenarios[0])
    } else {
      state.selectedScenario = undefined
    }
  },
  changeSelectedFlow (state, node) {
    let findNode = this.getters.findNodeByCode(node.code) // 자기 자신의 노드 찾기
    if (findNode !== undefined) {
      state.selectedFlow = findNode
      state.isSelectedFlow = true
    }
  },
  changeButtonOrder (state, buttons) {
    if (state.isSelectedFlow) {
      let parentNode = this.getters.findNodeByCode(state.selectedFlow.data.code) // 자기 자신의 부모 노드 찾기
      if (parentNode !== undefined) {
        parentNode.data.buttons = buttons
        parentNode.data.scenarioFlowStatus = 'CHANGED'
      }
    }
  },
  changeFlowTreeButtonOrder (state, buttons) {
    if (state.isSelectedFlow) {
      let parentNode = this.getters.findNodeByCode(state.selectedFlow.data.code) // 자기 자신의 부모 노드 찾기
      if (parentNode !== undefined) {
        let children = []
        let ordering = 1
        buttons.forEach(button => {
          if (button.buttonType === 'LINK_BUTTON') {
            let findNode = parentNode.children.find(e => e.data.code === button.code)
            findNode.data.ordering = ordering
            findNode.data.scenarioFlowStatus = 'CHANGED'
            children.push(findNode)
          } else {
            let temp = Object.assign({}, button)
            delete temp['buttonType']
            delete temp['code']
            delete temp['parentCode']
            let buttonContent = {
              text: button.name,
              children: [],
              data: {
                code: button.code,
                parentCode: state.selectedFlow.data.code,
                scenarioFlowStatus: 'CHANGED',
                templateType: button.buttonType,
                scenarioTemplateType: 'TEXT',
                ordering: ordering,
                buttons: [],
                buttonInfo: temp
              }
            }
            children.push(buttonContent)
          }
          ordering += 1
        })
        parentNode.children = children
      }
    }
  },
  generateTreeNode (state, tree) {
    state.treeNodes = tree
  },
  clearRemoveNodes (state) {
    state.deletedNodes = []
  },
  addChildNode (state, node) {
    let parentNode = this.getters.findNodeByCode(node.data.parentCode) // 자기 자신의 부모 노드 찾기
    if (parentNode !== undefined) {
      parentNode.children.push(node)
      parentNode.data.scenarioFlowStatus = 'CHANGED'
    }
  },
  addFlowButton (state, button) {
    let parentNode = this.getters.findNodeByCode(button.parentCode) // 자기 자신의 부모 노드 찾기
    if (parentNode !== undefined) {
      parentNode.data.buttons.push(button)
      parentNode.data.scenarioFlowStatus = 'CHANGED'
    }
  },
  updateFlowName (state, flow) {
    let findNode = this.getters.findNodeByCode(flow.data.code)
    if (findNode !== undefined) {
      findNode.text = flow.text
      findNode.data.scenarioFlowStatus = 'CHANGED'

      let temp = {name: flow.text}
      findNode.data.buttonInfo = temp
    }
  },
  updateFlowButton (state, button) {
    let parentNode = this.getters.findNodeByCode(button.parentCode) // 자기 자신의 부모 노드 찾기
    if (parentNode !== undefined) {
      parentNode.data.scenarioFlowStatus = 'CHANGED'
      let findButton = parentNode.data.buttons.find(e => e.code === button.code)
      if (findButton !== undefined) {
        findButton = button
      }
    }
    let node = this.getters.findNodeByCode(button.code)
    if (node !== undefined) {
      node.text = button.name
      if (button.buttonType === 'URL_BUTTON') {
        node.data.url = button.url
      }
      if (button.buttonType === 'TEL_BUTTON') {
        node.data.callNumber = button.callNumber
      }
      node.data.scenarioFlowStatus = 'CHANGED'

      let temp = Object.assign({}, button)
      delete temp['buttonType']
      delete temp['code']
      delete temp['parentCode']

      node.data.buttonInfo = temp
    }
  },
  deleteFlowButton (state, node) {
    let parentNode = this.getters.findNodeByCode(node.parentCode) // 자기 자신의 부모 노드 찾기

    if (parentNode !== undefined) {
      let findButton = parentNode.data.buttons.find(e => e.code === node.code)
      let findNode = parentNode.children.find(c => c.data.code === node.code)

      if (findNode !== undefined) {
        let nodeIndex = parentNode.children.indexOf(findNode)
        parentNode.children.splice(nodeIndex, 1)
      }

      if (findButton !== undefined) {
        let index = parentNode.data.buttons.indexOf(findButton)
        parentNode.data.buttons.splice(index, 1)
      }

      parentNode.data.scenarioFlowStatus = 'CHANGED'
    }
  },
  addDeletedNodes (state, node) {
    state.deletedNodes.push(node)
  },
  updateNode (state, node) {
    if (state.isSelectedFlow) {
      let childNode = state.selectedFlow.children.find(e => e.data.code === node.code)
      if (childNode !== undefined) {
        childNode.text = node.name
        childNode.data.text = node.name
        childNode.data.scenarioFlowStatus = 'CHANGED'
        eventBus.$emit('update-node', node)
      }
    }
  },
  changeFlowTemplate (state, type) {
    if (state.isSelectedFlow) {
      state.selectedFlow.data.scenarioTemplateType = type
      let node = this.getters.findNodeByCode(state.selectedFlow.data.code)
      if (node !== undefined) {
        node.data.scenarioTemplateType = type
        node.data.scenarioFlowStatus = 'CHANGED'
        // FIXME : 새로 생긴 자식 노드도 부모노드의 템플릿을 따르는 부분 주석처리
        // if (node.children) {
        //   node.children.forEach(e => {
        //     e.data.scenarioTemplateType = type
        //     e.data.scenarioFlowStatus = 'CHANGED'
        //   })
        // }
      }
    }
  },
  addTextContent (state, flow) {
    if (state.isSelectedFlow) {
      flow.data.textContent = {
        title: '',
        description: ''
      }
    }
  },
  updateTextContent (state, textContent) {
    if (state.isSelectedFlow) {
      state.selectedFlow.data.textContent.title = textContent.title
      state.selectedFlow.data.textContent.description = textContent.description

      let findNode = this.getters.findNodeByCode(textContent.code)
      findNode.data.textContent.title = textContent.title
      findNode.data.textContent.description = textContent.description
      findNode.data.scenarioFlowStatus = 'CHANGED'
    }
  },
  addImageContent (state, imageContent) {
    if (state.isSelectedFlow) {
      let findNode = this.getters.findNodeByCode(state.selectedFlow.data.code)
      if (findNode !== undefined) {
        findNode.data.imageContent = imageContent
        findNode.data.scenarioFlowStatus = 'CHANGED'
      }
    }
  },
  addListTemplate (state, listTemplate) {
    let parentNode = this.getters.findNodeByCode(listTemplate.parentCode) // 자기 자신의 부모 노드 찾기
    if (parentNode !== undefined) {
      if (parentNode.data.listTemplates === undefined) {
        parentNode.data.listTemplates = []
      }
      parentNode.data.listTemplates.push(listTemplate)
      parentNode.data.scenarioFlowStatus = 'CHANGED'
    }
  },
  deleteListTemplate (state, listTemplate) {
    let parentNode = this.getters.findNodeByCode(listTemplate.parentCode) // 자기 자신의 부모 노드 찾기
    if (parentNode !== undefined) {
      let findListTemplate = parentNode.data.listTemplates.find(e => e.code === listTemplate.code)
      if (findListTemplate !== undefined) {
        let index = parentNode.data.listTemplates.indexOf(findListTemplate)
        parentNode.data.listTemplates.splice(index, 1)
      }
      parentNode.data.scenarioFlowStatus = 'CHANGED'
    }
  },
  updateListTemplate (state, listTemplate) {
    let parentNode = this.getters.findNodeByCode(listTemplate.parentCode)
    if (parentNode !== undefined) {
      let template = parentNode.data.listTemplates.find(e => e.code === listTemplate.code)
      if (template !== undefined) {
        let index = parentNode.data.listTemplates.indexOf(template)
        parentNode.data.listTemplates[index] = listTemplate
        parentNode.data.scenarioFlowStatus = 'CHANGED'
      }
    }
  },
  updateScenarioName (state, scenario) {
    scenario.scenario.scenarioName = scenario.scenarioUpdateName
  },
  clearScenarios (state) {
    state.scenarios = []
  },
  openDisableScenarioDialog (state) {
    state.disableScenarioDialog = true
  },
  closeDisableScenarioDialog (state) {
    state.disableScenarioDialog = false
  },
  openDisableScenarioResultDialog (state) {
    state.disableScenarioResultDialog = true
  },
  closeDisableScenarioResultDialog (state) {
    state.disableScenarioResultDialog = false
  },
  changeScenarios (state, scenarios) {
    state.scenarios = scenarios
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/chatbot/index.js